// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
export const $themeColors = {};

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {};

// APP CONFIG
export const $themeConfig = {
  app: {
    appName: "mySkool", // Will update name in navigation menu (Branding)
    // eslint-disable-next-line global-require
    appLogoImage: "https://cdn.cloudious.net/file-1676144500973-1462800.png", // Will update logo in navigation menu (Branding)
    coverImage: "https://cdn.cloudious.net/file-1702898476612-648405343.png",
    // coverImage: require("@/assets/images/pages/Logo-01.png"),
  },
  layout: {
    isRTL: false,
    skin: "light", // light, dark, bordered, semi-dark
    routerTransition: "none", // none = no stuck pages; zoom-fade / page-fade caused lag
    type: "vertical", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      hidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: true,
  },
};
